import img from '../../../../assets/images/footer.png';
import * as styles from './styles';

export default function Img() {
  return (
    <styles.Container>
      <img src={img} alt="patterns" />
    </styles.Container>
  );
}
